import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import snackbarReducer from './snackbarSlice';
import permissionModalReducer from './permissionModalSlice';
import userReducer from '../api/user/userSlice';
import authReducer from '../api/auth/authSlice';
import loaderReducer from '../api/loader/loaderSlice';
import rootSaga from '../api/rootSaga';

const sagaMiddleware = createSagaMiddleware();

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  snackbar: snackbarReducer,
  loader: loaderReducer,
  permissionModal: permissionModalReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
